import { changeBrand, changeShop } from '../../auth/actions';

export const switchItem = item => (dispatch) => {
  if (item.type === 'shop') {
    return dispatch(changeShop(item.id));
  }

  if (item.type === 'brand') {
    return dispatch(changeBrand(item.id));
  }

  return false;
};
